import { render, staticRenderFns } from "./AppBottomNavBar.vue?vue&type=template&id=3059c164&scoped=true"
import script from "./AppBottomNavBar.vue?vue&type=script&lang=ts"
export * from "./AppBottomNavBar.vue?vue&type=script&lang=ts"
import style0 from "./AppBottomNavBar.vue?vue&type=style&index=0&id=3059c164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3059c164",
  null
  
)

export default component.exports